import { useParams, useLocation, Navigate } from "react-router-dom";
import { APP_ROUTES } from "./appRoutes";

/**
 * Handles legacy /{slug}/{gifId} URLs by redirecting to /ch/{slug}/{gifId}
 * Also handles numeric channel IDs (e.g., /60/123456 -> /ch/60/123456)
 * The MoveView component will handle ID->slug resolution if needed
 *
 * IMPORTANT: Preserves query strings and hash fragments for analytics tracking
 */
const LegacyGifRedirect = () => {
  const { slug, gifId } = useParams();
  const location = useLocation();

  // Don't redirect known app paths to /ch/ — send to root instead.
  if (APP_ROUTES.has(slug)) {
    return <Navigate to="/" replace />;
  }

  // Redirect to the canonical /ch/{slug}/{gifId} URL, preserving query params and hash
  return (
    <Navigate
      to={`/ch/${slug}/${gifId}${location.search}${location.hash || ""}`}
      replace
    />
  );
};

export default LegacyGifRedirect;
